export var compareTimeUpdateEvents=function(e,r){return e.currentDate===r.currentDate&&e.currentTime===r.currentTime&&e.isAtLiveEdge===r.isAtLiveEdge};